import PropTypes from 'prop-types';

export const SpendLimitsPropType = PropTypes.shape({
  daily_limit: PropTypes.string.isRequired,
  weekly_limit: PropTypes.string.isRequired,
  pump_limit: PropTypes.string,
});
